import { HTMLAttributes } from "react"

export default function UpStash(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="118"
      height="118"
      viewBox="0 0 118 118"
      fill="none"
    >
      <g clipPath="url(#upstash_icon_white_bg)">
        <path
          fill="#00C98D"
          d="M15.105 102.66c19.416 19.416 50.895 19.416 70.311 0 19.416-19.415 19.416-50.895 0-70.31l-8.789 8.788c14.562 14.562 14.562 38.172 0 52.733-14.562 14.562-38.171 14.562-52.733 0l-8.789 8.789Z"
        />
        <path
          fill="#00C98D"
          d="M32.683 85.083c9.708 9.707 25.447 9.707 35.155 0 9.708-9.708 9.708-25.448 0-35.156l-8.788 8.789c4.854 4.854 4.854 12.724 0 17.578-4.855 4.854-12.724 4.854-17.578 0l-8.79 8.789Z"
        />
        <path
          fill="#00C98D"
          d="M102.994 14.771c-19.416-19.415-50.895-19.415-70.311 0-19.416 19.416-19.416 50.896 0 70.312l8.788-8.79c-14.561-14.561-14.561-38.17 0-52.733 14.562-14.562 38.172-14.562 52.734 0l8.789-8.789Z"
        />
        <path
          fill="#00C98D"
          d="M85.416 32.35c-9.708-9.709-25.448-9.709-35.156 0-9.708 9.707-9.708 25.447 0 35.155l8.79-8.79c-4.855-4.853-4.855-12.723 0-17.577 4.853-4.854 12.723-4.854 17.577 0l8.789-8.789Z"
        />
        <path
          fill="#fff"
          fillOpacity=".4"
          d="M102.994 14.771c-19.416-19.415-50.896-19.415-70.312 0-19.416 19.416-19.416 50.896 0 70.312l8.79-8.79c-14.563-14.561-14.563-38.17 0-52.733 14.561-14.562 38.17-14.562 52.732 0l8.79-8.789Z"
        />
        <path
          fill="#fff"
          fillOpacity=".4"
          d="M85.416 32.35c-9.708-9.709-25.448-9.709-35.156 0-9.708 9.707-9.708 25.447 0 35.155l8.79-8.79c-4.855-4.853-4.855-12.723 0-17.577 4.853-4.854 12.723-4.854 17.577 0l8.789-8.789Z"
        />
      </g>
      <defs>
        <clipPath id="upstash_icon_white_bg">
          <path fill="#fff" d="M15 0h88v117.333H15z" />
        </clipPath>
      </defs>
    </svg>
  )
}
